import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
// Reusing some existing photos and adding placeholders for the years
const galleries = {
  '2026': [{
    src: 'https://cdn.magicpatterns.com/uploads/jGC4ZG2FsPpXtRMHQBJfvE/16-9-fullframe-export_(0;01;25;27)_I.jpg',
    alt: 'Flotila na moři'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9iUbMW7EXRNfa4RJsoELHD/16-9-fullframe-export_(0;00;41;00)_molo.jpg',
    alt: 'Marina při západu slunce'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mVDLYHkJDEjdFbcn2ZjTWE/16-9-fullframe-export_(0;01;31;28)_detIII.jpg',
    alt: 'Detail kladky'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9xtP2ahJTe57vkbeYt22Az/16-9-fullframe-export_(0;01;32;27)_detII.jpg',
    alt: 'Detail ráhna'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mukNHx9uaN2UkH4Wg5ELUP/DSC01389.jpg',
    alt: 'Plachetnice v závodě'
  }],
  '2025': [{
    src: 'https://cdn.magicpatterns.com/uploads/2iGFN2sHZ72jzpWMpYnUu2/16-9-fullframe-export_(0;01;44;15)_detI.jpg',
    alt: 'Západ slunce'
  },
  // Adding some generic sailing placeholders to fill out the 2025 gallery
  {
    src: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&q=80&w=1000',
    alt: 'Plachetnice'
  }, {
    src: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=1000',
    alt: 'Moře'
  }, {
    src: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&q=80&w=1000',
    alt: 'Pobřeží'
  }]
};
export function GalleryPage() {
  const [activeYear, setActiveYear] = useState<'2026' | '2025'>('2026');
  // Load custom photos from localStorage
  const customPhotos = JSON.parse(localStorage.getItem('fch_custom_photos') || '[]');
  const filteredCustom = customPhotos.filter((p: any) => p.year === activeYear);
  // Combine hardcoded and custom photos
  const allPhotos = [...filteredCustom, ...galleries[activeYear]];
  return <main className="pt-32 pb-24 min-h-screen bg-off-white" data-id="element-274">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-275">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-276">
          <h1 className="text-4xl md:text-5xl font-light text-navy-deep mb-6" data-id="element-277">
            Fotogalerie
          </h1>

          {/* Year selector */}
          <div className="flex justify-center gap-4" data-id="element-278">
            {(['2026', '2025'] as const).map(year => <button key={year} onClick={() => setActiveYear(year)} className={`px-6 py-2 rounded-full text-lg font-medium transition-all duration-300 ${activeYear === year ? 'bg-blue-medium text-white shadow-md' : 'bg-white text-navy-deep/70 hover:bg-mist'}`} data-id="element-279">
                Ročník {year}
              </button>)}
          </div>
        </motion.div>

        {/* Gallery Grid */}
        <motion.div key={activeYear} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-280">
          {allPhotos.map((photo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="group relative aspect-[4/3] overflow-hidden rounded-xl shadow-sm cursor-pointer bg-mist" data-id="element-281">
              <img src={photo.src} alt={photo.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-282" />
              <div className="absolute inset-0 bg-navy-deep/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-283" />
            </motion.div>)}
        </motion.div>
      </div>
    </main>;
}